'use strict';
angular.module('edApp').factory('newsResource', ['$resource', newsResource]);

function newsResource($resource) {

    var resource = $resource("/umbraco/api/news/:methodName", {}, {
        getNewsItems: { method: 'GET', params: { methodName: 'getNewsItems' }, isArray: true },
        getYears: { method: 'GET', params: { methodName: 'getYears' }, isArray: true },
        getMonths: { method: 'GET', params: { methodName: 'getMonths' }, isArray: true }
    });

    return resource;
}